import React, { Fragment, useState } from "react";
import { Redirect } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BlueLogo from "../layout/Employers/BlueLogo";
import SubscribeIMEEmployer from "../layout/IME/SubscribeIMEEmployer";

const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBILC_KEY;

const stripePromise = loadStripe(STRIPE_KEY);

const SetupEmployer = ({ match, auth: { user, isAuthenticated } }) => {
  const [showEmployerSubscription, setShowEmployerSubscription] =
    useState(false);
  const [selectedPlan, setSelectedPlan] = useState({
    price: 0,
    silver: false,
    gold: false,
    platinum: false,
  });

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {showEmployerSubscription && (
        <Elements stripe={stripePromise}>
          <SubscribeIMEEmployer
            match={match}
            user={user}
            setSelectedPlan={setSelectedPlan}
            selectedPlan={selectedPlan}
            setShowEmployerSubscription={setShowEmployerSubscription}
          />
        </Elements>
      )}
      <div class="container-two">
        <div class="initialize-title">
          <div class="flex">
            <div class="logo-setup">
              <BlueLogo />
            </div>
            <h1 class="setup-heading blue">Choose your ime Employer Plan</h1>
          </div>
          <p class="lead px-20">Let's get started!</p>
        </div>
        <div class="container-two">
          <div class="section-info">
            <p class="setup-info px-20">
              Choose a subscription tailored toward your recruiting demands:
            </p>
          </div>
          <section class="subs">
            <div class="subscriptions">
              <div class="subscription">
                <div class="subscription-logo-container">
                  <div class="subscription-logo">
                    <BlueLogo />
                  </div>
                </div>
                <p class="subscription-title blue">Silver Package</p>
                <div class="subscription-body">
                  <div>
                    <p class="subscription-description">
                      ime's Silver Package consists of one (1) job posting for
                      30 days, alongside one (1) Job Live Stream and one (1) VR
                      Tour post. This package is tailored towards employers
                      looking to hire for a small team.
                    </p>
                  </div>
                  <div>
                    <div class="subscription-price">
                      <p class="price blue">$100.00 / month</p>
                      <br />
                      <p class="disclaimer">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Iste laborum perferendis cum iusto quod molestiae ab
                        nisi? Optio, enim iste.
                      </p>
                    </div>
                    <button
                      class="subscription-button background-blue"
                      onClick={() => {
                        setShowEmployerSubscription(true);
                        setSelectedPlan({
                          price: 10000,
                          silver: true,
                          gold: false,
                          platinum: false,
                        });
                      }}
                    >
                      Subscribe Now!
                    </button>
                  </div>
                </div>
              </div>
              <div class="subscription">
                <div class="subscription-logo-container">
                  <div class="subscription-logo">
                    <BlueLogo />
                  </div>
                </div>
                <p class="subscription-title blue">Gold Package</p>
                <div class="subscription-body">
                  <div>
                    <p class="subscription-description">
                      ime's Gold Package provides you with the ability to post
                      up to 50 job postings in a month, expiring 30 days after
                      initial posting. Each job post is parterned with one (1)
                      Job Stream and one (1) VR Tour per post.
                    </p>
                  </div>
                  <div>
                    <div class="subscription-price">
                      <p class="price blue">$300.00 / month</p>
                      <br />
                      <p class="disclaimer">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Iste laborum perferendis cum iusto quod molestiae ab
                        nisi? Optio, enim iste.
                      </p>
                    </div>
                    <button
                      class="subscription-button background-blue"
                      onClick={() => {
                        setShowEmployerSubscription(true);
                        setSelectedPlan({
                          price: 30000,
                          silver: false,
                          gold: true,
                          platinum: false,
                        });
                      }}
                    >
                      Subscribe Now!
                    </button>
                  </div>
                </div>
              </div>
              <div class="subscription">
                <div class="subscription-logo-container">
                  <div class="subscription-logo">
                    <BlueLogo />
                  </div>
                </div>
                <p class="subscription-title blue">Platinum Package</p>
                <div class="subscription-body">
                  <div>
                    <p class="subscription-description">
                      Looking to get the most out of your recruiting efforts?
                      ime's Platinum Package is the best fit for you! Post up to
                      75 jobs per month, expiring 30 days after initial posting.
                      These job postings are also paired with one (1) Job Stream
                      and one (1) VR Tour per post. Reach a large audience and
                      explore the many talented and motivated innovators looking
                      to make a difference within your company.The Platinum
                      Package is best tailored for employers looking to hire
                      frequently and for large teams.
                    </p>
                  </div>
                  <div>
                    <div class="subscription-price">
                      <p class="price blue">$500.00 / month</p>
                      <br />
                      <p class="disclaimer">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Iste laborum perferendis cum iusto quod molestiae ab
                        nisi? Optio, enim iste.
                      </p>
                    </div>
                    <button
                      class="subscription-button background-blue"
                      onClick={() => {
                        setShowEmployerSubscription(true);
                        setSelectedPlan({
                          price: 50000,
                          silver: false,
                          gold: false,
                          platinum: true,
                        });
                      }}
                    >
                      Subscribe Now!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Fragment>
  );
};

SetupEmployer.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(SetupEmployer);
